import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import store from "../store/index.js";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import("../views/HomeView.vue")
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: "/ForgotPassword",
    name: "ForgotPassword",
    component: () => import("../views/ForgotPassword.vue")
  },
  {
    path: "/ResetPassword/:token/:email",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue")
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name !== "Login" && to.name !== "ForgotPassword" && to.name !== "ResetPassword" && !store.getters.isAuthenticated) next({ name: "Login" })
  next()
})

export default router
